import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {Config, getConfig, getLookups, initialConfigState, initialLookupsState, Lookups} from "../../../../redux";
import {Store} from "@ngrx/store";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormControl, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {IDealHighlightsRequest} from "../../../models";
import { LookupService } from 'src/app/services';
import { DataService } from 'src/app/services/data/data.service';

@Component({
  selector: 'app-deal-highlights-modal',
  templateUrl: './deal-highlights-modal.component.html',
  styleUrls: ['./deal-highlights-modal.component.scss']
})
export class DealHighlightsModalComponent implements OnInit {

  userForm = new FormGroup({
    isIssuerNdaSigned: new FormControl(false),
    isDealNdaSigned: new FormControl(false),
    investorWorkflowStatus: new FormControl()
  });

  constructor(private router: Router,
              private dataService: DataService,
              public lookupService: LookupService,
              public dialogRef: MatDialogRef<DealHighlightsModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {

  }


  ngOnInit(): void {
    if (!!this.data) {
      this.userForm.patchValue(this.data);
    }
  }

  submit() {
    let payload = this.userForm.value as IDealHighlightsRequest;
    payload.id = this.data.dealMatchId;
    this.dialogRef.close(payload);
  }

  view(user: any) {
    if (!!user.id) {
      this.router.navigate(['/' + this.dataService.getBuSlug() + '/users/' + user.id]).then(() => {
        this.dialogRef.close();
      });
    }
  }

}
